import { Trans, useTranslation } from 'react-i18next';

import Button from '../../ui/Button';
import Modal from '../../ui/Modal';

type DeleteConfirmModalProps = {
  groupName: string;
  onCancel: () => void;
  onConfirm: () => void;
};

const modalActionsStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 'min(2em, 2vh)',
};

const buttonStyle: React.CSSProperties = {
  margin: '0 min(1em, 2vw)',
};

const DeleteConfirmModal = (props: DeleteConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={props.onCancel}>
      <p>
        <Trans
          i18nKey="modals.delete"
          values={{ groupName: props.groupName }}
          components={[<span style={{ fontStyle: 'italic' }}>placeholder</span>]}
        />
      </p>
      <div style={modalActionsStyle}>
        <Button extraStyles={buttonStyle} onClick={props.onCancel}>
          {t('buttons.cancel')}
        </Button>
        <Button extraStyles={buttonStyle} onClick={props.onConfirm}>
          {t('buttons.confirm')}
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
